import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import { config } from "@/config";
import type { CameraTrapsGeoJsonResponse } from "./type";

async function getCameraTrapsGeoJson(
  query?: string,
): Promise<CameraTrapsGeoJsonResponse> {
  const params = new URLSearchParams();

  if (query) {
    params.append("number", query);
  }

  const url = `${apiPaths.devices.cameraTraps.getGeoJson}?${params.toString()}`;
  const response = await apiClient.get<CameraTrapsGeoJsonResponse>(url);

  return response.data;
}

export function useGetCameraTrapsGeoJson(
  query?: string,
  options?: SWRConfiguration & { enabled?: boolean },
) {
  const enabled = options?.enabled ?? true;

  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    enabled
      ? [`fetch-camera-traps-geojson`, JSON.stringify(query ?? {})]
      : null,
    () => getCameraTrapsGeoJson(query),
    mergedOptions,
  );
}
